import { EWalletId, getIsTrustWalletInjected } from '@ankr.com/provider';
import { isMobile } from 'web3modal';

import { getMobileWalletCallbackURL } from '../utils/getMobileWalletCallbackURL';
import { WalletButton } from './WalletButton';

const DOWNLOAD_TRUST_URL = 'https://trustwallet.com/';
export const TRUST_WALLET_ID = EWalletId.trust;

interface Props {
  loading?: boolean;
  onConnect: (walletId: EWalletId) => void;
}

export function TrustWallet({ loading, onConnect }: Props): JSX.Element {
  const callback = getMobileWalletCallbackURL(TRUST_WALLET_ID);
  const MOBILE_DEEP_LINK = `https://link.trustwallet.com/open_url?coin_id=714&url=${callback}`;

  const trustWalletInjected = window?.trustwallet;

  if (isMobile()) {
    return (
      <WalletButton
        walletId={TRUST_WALLET_ID}
        link={MOBILE_DEEP_LINK}
        disabled={loading}
        onClick={
          trustWalletInjected ? () => onConnect(TRUST_WALLET_ID) : undefined
        }
      />
    );
  }

  return (
    <WalletButton
      walletId={TRUST_WALLET_ID}
      disabled={loading}
      onClick={() => onConnect(TRUST_WALLET_ID)}
      installLink={getIsTrustWalletInjected() ? '' : DOWNLOAD_TRUST_URL}
    />
  );
}
